import { render, staticRenderFns } from "./ktp.vue?vue&type=template&id=accfe66a&"
import script from "./ktp.vue?vue&type=script&lang=js&"
export * from "./ktp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports